import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiLogo } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const B2bMulticolorDarkHorizontalLogo = makeTamagoshiLogo(
  (props, ref) => {
    return (
      <Svg
        width="232"
        height="42"
        fill="none"
        viewBox="0 0 232 42"
        xmlns="http://www.w3.org/2000/svg"
        optimizationId="tama-b2b-multicolor-dark-horizontal"
        {...props}
        ref={ref}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M205.4 17.9c0 2-.6 3.6-1.7 4.7a6.94 6.94 0 0 1-4.9 1.7h-1.3v6h-4.7V12.1h6.1c2.2 0 3.9.5 5 1.5.9 1 1.5 2.4 1.5 4.3Zm-8 2.3h.9c.7 0 1.3-.2 1.7-.6.4-.4.6-1 .6-1.7 0-1.2-.7-1.8-2-1.8h-1.2v4.1Zm19.8-4.2c-.4-.1-.8-.1-1.2-.1-.7 0-1.4.3-2.1.7-.7.5-1.2 1.1-1.6 1.8h-.2l-.7-2.2h-3.5v14h4.7v-6.9c0-.9.2-1.6.7-2.1.4-.5 1.2-.7 2.2-.7.7 0 1.2 0 1.6.1l.4-4.6h-.3Zm2.7 2.1c1.4-1.4 3-2 5-2s3.7.6 5 2c1.4 1.3 2 3 2 5.1 0 2.1-.7 3.8-2 5.1-1.3 1.3-3 1.9-5 1.9s-3.7-.6-5-1.9c-1.3-1.3-2-3-2-5.1 0-2.1.6-3.8 2-5.1Zm7.7 5.1c0 1.9-1.2 3.1-2.7 3.1-1.5 0-2.7-1.2-2.7-3.1 0-1.8 1.2-3.1 2.7-3.1 1.5 0 2.7 1.2 2.7 3.1Z"
          fill="#FFB950"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M104.9 18.9c1.4-1.3 3.1-1.9 5.1-1.9 2 0 3.7.6 5.1 1.9 1.4 1.3 2.1 2.9 2.1 4.9 0 2-.7 3.6-2.1 4.9-1.4 1.2-3 1.9-5.1 1.9-2 0-3.7-.6-5.1-1.9-1.4-1.3-2-2.9-2-4.9 0-2 .7-3.6 2-4.9Zm5.1 7.8c1.5 0 2.7-1.2 2.7-2.9 0-1.8-1.2-3-2.7-3-1.5 0-2.7 1.2-2.7 3s1.2 2.9 2.7 2.9ZM97 17c3.1 0 4.4 1.6 4.4 4.4v8.8h-5v-7.8c0-.8-.3-1.3-.9-1.3-.6 0-1.7.2-2.5.7v8.4h-4.9v-13h4.1l.3 1c.8-.5 2.7-1.2 4.2-1.2h.3Zm-32.2-2.5 7.1 1.2v14.9l-5.2 1.7v-12l-5.5 9.5h-2.9l-3.7-8.9-3.6 9.3h-5.6l6.2-15.8 5-1.3 4.1 8.5 4.1-7.1Zm9.9 3.2c3.6-.6 11.7-2.5 11.7 4.7v7.9h-3.8l-.3-.6s-1.3 1-4.1 1c-3.1 0-4.7-2.1-4.7-4.1 0-3.3 3-4.1 6.3-4.1h2.3c0-1.3-.8-1.8-2.6-1.8-2.5 0-4.5.5-4.9.7v-3.7h.1Zm7.5 7.6v-.1H80c-1.7 0-2.6.3-2.6 1.1 0 .9.7 1.2 1.9 1.2 1.9 0 2.9-.7 2.9-2.2Zm95.2-6.4c1.4-1.3 3.1-1.9 5.1-1.9 2 0 3.7.6 5.1 1.9 1.4 1.3 2.1 2.9 2.1 4.9 0 2-.7 3.6-2.1 4.9-1.4 1.2-3 1.9-5.1 1.9-2 0-3.7-.6-5.1-1.9-1.4-1.3-2-2.9-2-4.9 0-2 .6-3.6 2-4.9Zm5.1 7.8c1.5 0 2.7-1.2 2.7-2.9 0-1.8-1.2-3-2.7-3-1.5 0-2.7 1.2-2.7 3s1.2 2.9 2.7 2.9Zm-13-9.7c3.1 0 4.4 1.6 4.4 4.4v8.8H169v-7.8c0-.8-.3-1.3-.9-1.3-.6 0-1.7.2-2.5.7v8.4h-4.9v-13h4.1l.3 1c.8-.5 2.7-1.2 4.2-1.2h.2Zm-32.2-2.5 7.1 1.2v14.9l-5.2 1.7v-12l-5.5 9.5h-2.8l-3.7-8.9-3.8 9.3h-5.6l6.2-15.8 5-1.3 4.1 8.5 4.2-7.1Zm9.8 3.2c3.6-.6 11.7-2.5 11.7 4.7v7.9H155l-.3-.6s-1.3 1-4.1 1c-3.1 0-4.7-2.1-4.7-4.1 0-3.3 3-4.1 6.3-4.1h2.3c0-1.3-.8-1.8-2.6-1.8-2.5 0-4.5.5-4.9.7v-3.7h.1Zm7.5 7.6v-.1h-2.2c-1.7 0-2.6.3-2.6 1.1 0 .9.7 1.2 1.9 1.2 1.9 0 2.9-.7 2.9-2.2Z"
          fill="#0C193A"
        />
        <path
          d="m27.6 0-18 2.94c-1.3.2-2.4 1.12-2.8 2.34L.3 22.52c-.2.5-.3.91-.3 1.32 0 .81.3 1.62.8 2.33l11.5 14.41c.7.91 1.8 1.32 2.8 1.42h.6l18-2.94c1.3-.2 2.4-1.12 2.9-2.34l6.5-17.24a3.5 3.5 0 0 0-.6-3.65L31.1 1.42A3.83 3.83 0 0 0 28.2 0h-.6Z"
          fill="url(#tama-b2b-multicolor-dark-horizontal)"
        />
        <path
          d="m26.3 12.4-4.1 7.1-4-8.4-5 1.3-6.1 15.7h5.5l3.7-9.3 3.6 8.8h2.8l5.5-9.4v12.1l5.1-1.7v-15l-7-1.2Z"
          fill="#fff"
        />
        <defs>
          <linearGradient
            id="tama-b2b-multicolor-dark-horizontal"
            x1="7.5"
            y1="32.97"
            x2="31.71"
            y2="13.11"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E6685A" />
            <stop offset="1" stopColor="#FFB950" />
          </linearGradient>
        </defs>
      </Svg>
    );
  },
);

B2bMulticolorDarkHorizontalLogo.displayName = 'B2bMulticolorDarkHorizontalLogo';
